module.exports = __webpack_public_path__ + "static/capacitacao-bf1e347337866fb159ee42055fbeb7c2.jpg";